import React from 'react'
// import PT from 'prop-types'
import { Link } from 'react-router-dom'
import { Grid, Row, Col } from 'react-bootstrap'
import Plyr from 'react-plyr'
import PostsContainer from '../Post/PostsContainer'
import './home89.css'

const Home = () => (
  <div className="Home">
    <Grid className="intro intro89">
      <Row>
        <Col xs={12} md={6}>
          <h2>
            Čo ste robili v<br />novembri 1989?
            <br />
            <Link to="/89/pridat" className="green">Zaujíma nás váš príbeh</Link>
          </h2>
          <Link className="pridat89" to="/89/pridat">Pridajte príbeh</Link>
        </Col>
        <Col xsHidden smHidden md={6}>
          <Plyr type="youtube" videoId="ZsJGJOUVW3A" />
        </Col>
      </Row>
    </Grid>
    <PostsContainer />
  </div>
)

export default Home



// WEBPACK FOOTER //
// ./src/components/89/Home89.js